import { render } from "./Supplier.vue?vue&type=template&id=03fd553b&scoped=true"
import script from "./Supplier.vue?vue&type=script&lang=js"
export * from "./Supplier.vue?vue&type=script&lang=js"

import "./Supplier.vue?vue&type=style&index=0&id=03fd553b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fd553b"]])

export default __exports__